import React from "react";
import { ThemeProvider } from "styled-components";
import GlobalStyle from "../src/GlobalStyle"
import Header from "./components/Header";
import Home from "./components/Home";
import {Snow} from "./components/Snow";
import { themes, ThemeSwitcher } from "./ThemeSwitcher";
import GoUp from "./components/GoUp";
import { animateScroll as scroll } from "react-scroll";
import { BottomNavPanel } from "./components/BottomNavPanel";
import styled from "styled-components";
function App() {
  const [theme, setTheme] = React.useState("light");
  const [arrow, setArrow] = React.useState(false);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const handleScrollTop = () => {
    if (window.scrollY >= 1300) {
      setArrow(true);
    } else {
      setArrow(false);
    }
  };

  window.addEventListener("scroll", handleScrollTop);

  return (
    <ThemeSwitcher.Provider value={theme}>
      <ThemeProvider theme={themes[theme]}>
        <Snow />
        <Header theme={theme} switchTheme={setTheme} />
        <GlobalStyle />
        <ReactIconOne src="/images/source.gif" alt="icon" />
        <ReactIconTwo src="/images/source.gif" alt="icon" />
        <Home />
        {arrow ? <GoUp scrollUp={scrollToTop} active={arrow} /> : "" }
      <BottomNavPanel theme={theme} switchTheme={setTheme}/>
      </ThemeProvider>
    </ThemeSwitcher.Provider>
  );
}

export default App;


const ReactIconOne = styled.img`
  width: 220px;
  position: fixed;
  z-index: 2;
  right: -120px;
  top: -100px;
  @media (max-width: 768px) {
    display: none;
  }
`
const ReactIconTwo = styled.img`
  width: 220px;
  position: fixed;
  z-index: 2;
  left: -120px;
  bottom: -100px;
  @media (max-width: 768px) {
    display: none;
  }
`